<template>
  <UpgradeFeatureModal v-if="featureUpgrade" :featureUpgrade="featureUpgrade" @close="close" />
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mapState, mapStores } from 'pinia'
import UpgradeFeatureModal from '@/modules/featurerestriction/components/UpgradeFeatureModal.vue'
import { UpgradeFeatureModalStore, useUpgradeFeatureModalStore } from '@/modules/global/stores/UpgradeFeatureModalStore'
import { FeatureUpgrade } from '../models/FeatureUpgrade'

@Component({
  components: {
    UpgradeFeatureModal
  },
  computed: {
    ...mapState(useUpgradeFeatureModalStore, ['featureUpgrade']),
    ...mapStores(useUpgradeFeatureModalStore)
  }
})
export default class UpgradeFeatureModalProvider extends Vue {
  private featureUpgrade!: FeatureUpgrade
  upgradeFeatureModalStore!: UpgradeFeatureModalStore

  close() {
    this.upgradeFeatureModalStore.hideUpgradeFeatureModal()
  }
}
</script>

<style scoped lang="scss"></style>
